var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTwitterThumb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#1DA1F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6607 24.7511C20.3392 24.7511 24.5389 18.3896 24.5389 12.8729C24.5389 12.6922 24.539 12.5123 24.5267 12.3333C25.3438 11.7423 26.049 11.0106 26.6095 10.1723C25.8476 10.5099 25.0394 10.7313 24.2118 10.8292C25.0833 10.3074 25.7355 9.48682 26.0471 8.52008C25.2276 9.00636 24.3311 9.34906 23.3962 9.5334C22.7668 8.86411 21.9343 8.42092 21.0276 8.27242C20.1209 8.12392 19.1906 8.27838 18.3805 8.7119C17.5705 9.14543 16.9259 9.83385 16.5465 10.6706C16.1671 11.5074 16.0741 12.4459 16.2818 13.3409C14.622 13.2577 12.9983 12.8264 11.516 12.0749C10.0338 11.3235 8.72611 10.2687 7.67793 8.97913C7.14408 9.89817 6.98057 10.9861 7.22069 12.0215C7.46082 13.0568 8.08653 13.9618 8.97042 14.552C8.30606 14.5323 7.65618 14.3531 7.07563 14.0295C7.07563 14.0466 7.07563 14.0645 7.07563 14.0824C7.0759 15.0462 7.40955 15.9803 8.02 16.7262C8.63045 17.4721 9.48012 17.9839 10.4249 18.1747C9.81027 18.3423 9.16542 18.3668 8.53986 18.2463C8.80663 19.0759 9.32599 19.8013 10.0253 20.3211C10.7246 20.8409 11.5689 21.1291 12.4401 21.1455C10.9619 22.3073 9.13569 22.938 7.25551 22.9361C6.92335 22.9355 6.59152 22.9154 6.26172 22.8759C8.17086 24.101 10.3923 24.7509 12.6607 24.7479",
    fill: "white"
  })));
}

export default SvgTwitterThumb;